import { render } from "./SenderInformationPage.vue?vue&type=template&id=3d66e7c3"
import script from "./SenderInformationPage.vue?vue&type=script&lang=js"
export * from "./SenderInformationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__